import React, { useEffect, useState } from 'react';
import {fetchWithAuth} from "../utils/fetchWithAuth";

function HistoryPage() {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    fetchWithAuth("/history", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
      .then((res) => res.json())
      .then(setHistory)
      .catch((err) => console.error("히스토리 불러오기 실패", err));
  }, []);


  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50 dark:from-gray-900 dark:to-gray-800 px-6 py-12 flex flex-col items-center text-gray-800 dark:text-white">
      <h2 className="text-2xl sm:text-3xl font-extrabold text-blue-700 dark:text-blue-300 mb-6 text-center drop-shadow">
        📜 저장된 문장 히스토리
      </h2>

      {history.length === 0 ? (
        <p className="text-gray-500 dark:text-gray-300">저장된 문장이 없습니다.</p>
      ) : (
        <ul className="w-full max-w-3xl space-y-6">
          {history.map((item, idx) => (
            <li
              key={item.id || idx}
              className="relative bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-md border border-blue-100 dark:border-gray-700 transition hover:shadow-lg"
            >
              <p className="mb-2">
                <span className="font-semibold text-gray-700 dark:text-gray-200">🎯 목적:</span> {item.purpose}
              </p>
              <p className="mb-2">
                <span className="font-semibold text-gray-700 dark:text-gray-200">📝 입력:</span> {item.input_text}
              </p>
              <p className="mb-2">
                <span className="font-semibold text-gray-700 dark:text-gray-200">🎤 말투:</span> {item.tone}
              </p>
              <p className="mb-2 whitespace-pre-line">
                <span className="font-semibold text-gray-700 dark:text-gray-200">✅ 결과:</span><br />
                {item.result_text}
              </p>
              <p className="text-sm text-gray-400 dark:text-gray-500 mt-2">
                {new Date(item.created_at).toLocaleString()}
              </p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default HistoryPage;
